import { Contact, OrganizationTableItem } from 'types'

export const buildContactTreeRows = (contacts: Contact[] | [], deals: OrganizationTableItem[]) => {
  const rows: any[] = []
  const seenTreePaths = new Set<string>()
  const seenRowIds = new Set<string>()
  contacts.forEach((contact: Contact) => {
    const relatedDeals =
      deals.filter(
        d =>
          d?.contacts?.includes(contact?.contacts_uuid) ||
          d?.recipients?.[0]?.contactRecipient?.[0]?.id === contact?.contacts_uuid
      ) ?? []
    const contactId = `CONTACT_${contact?.contacts_uuid}::CREATION_TIMSTAMP_${contact?.timeCreated}}`

    // Ensure top-level treePath is unique
    let topLabel = `${contact.name} (${contact.contacts_uuid})`
    let contactPathKey = topLabel
    let k = 1
    while (seenTreePaths.has(contactPathKey)) {
      topLabel = `${contact.name} (${contact.contacts_uuid}) (${k})`
      contactPathKey = topLabel
      k++
    }
    const topTreePath = [topLabel]

    const contactRow = {
      ...contact,
      id: contactId,
      rowId: contactId,
      treePath: topTreePath,
      isParent: true,
    }
    rows.push(contactRow)
    seenTreePaths.add(contactPathKey)
    seenRowIds.add(contactId)

    relatedDeals.forEach((deal) => {
      const dealId = `${deal.PK}::${deal.SK}`

      // Ensure deal treePath is unique
      let dealLabel = `${deal?.name}-${deal?.deal_uuid}`
      let dealPathKey = `${topLabel} > ${dealLabel}`
      let i = 1
      while (seenTreePaths.has(dealPathKey)) {
        dealLabel = `${dealLabel} (${i})`
        dealPathKey = `${topLabel} > ${dealLabel}`
        i++
      }
      const subtaskTreePath = [topLabel, dealLabel]

      const dealRow = {
        ...deal,
        rowId: `${contactRow?.rowId}::${dealId}`,
        parentId: contactRow?.rowId,
        id: dealId,
        treePath: subtaskTreePath,
        isDeal: true,
      }
      rows.push(dealRow)
      seenTreePaths.add(dealPathKey)
      seenRowIds.add(dealId)
    })
  })

  return rows
}
